var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "resbdadjustsourcehouse" }, [
    _c("div", { staticClass: "nav" }, [
      _c(
        "div",
        { staticClass: "nav-btn", style: "background:" + _vm.themeColor + ";" },
        [
          _vm._v("\n           批量操作\n          "),
          _c("div", { staticClass: "nav-btn_ul" }, [
            _c(
              "div",
              {
                staticClass: "nav-btn_li",
                on: {
                  click: function ($event) {
                    return _vm.operation("insert_unithold")
                  },
                },
              },
              [_vm._v("插入整列")]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "nav-btn_li",
                on: {
                  click: function ($event) {
                    return _vm.operation("insert_floor")
                  },
                },
              },
              [_vm._v("插入整行")]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "nav-btn_li",
                on: {
                  click: function ($event) {
                    return _vm.operation("delete_unithold")
                  },
                },
              },
              [_vm._v("删除整列")]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "nav-btn_li",
                on: {
                  click: function ($event) {
                    return _vm.operation("delete_floor")
                  },
                },
              },
              [_vm._v("删除整行")]
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "nav-btn_triangle" }),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "nav-btn", style: "background:" + _vm.themeColor + ";" },
        [
          _vm._v("\n         合并拆分\n         "),
          _c("div", { staticClass: "nav-btn_ul" }, [
            _c(
              "div",
              {
                staticClass: "nav-btn_li",
                on: {
                  click: function ($event) {
                    return _vm.merge(0)
                  },
                },
              },
              [_vm._v("向右合并")]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "nav-btn_li",
                on: {
                  click: function ($event) {
                    return _vm.merge(1)
                  },
                },
              },
              [_vm._v("向左合并")]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "nav-btn_li",
                on: {
                  click: function ($event) {
                    return _vm.operation("split_room")
                  },
                },
              },
              [_vm._v("房间拆分")]
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "nav-btn_triangle" }),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "nav-btn", style: "background:" + _vm.themeColor + ";" },
        [
          _vm._v("\n         房间操作\n         "),
          _c("div", { staticClass: "nav-btn_ul" }, [
            _c(
              "div",
              {
                staticClass: "nav-btn_li",
                on: {
                  click: function ($event) {
                    return _vm.operation("new_room")
                  },
                },
              },
              [_vm._v("新增房间")]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "nav-btn_li",
                on: {
                  click: function ($event) {
                    return _vm.operation("edit_room")
                  },
                },
              },
              [_vm._v("修改房间")]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "nav-btn_li",
                on: {
                  click: function ($event) {
                    return _vm.operation("delete_room")
                  },
                },
              },
              [_vm._v("删除房间")]
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "nav-btn_triangle" }),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "nav-btn",
          style: "background:" + _vm.themeColor + ";",
          on: {
            click: function ($event) {
              return _vm.exit()
            },
          },
        },
        [_vm._v("退出")]
      ),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "content" }, [
      _c(
        "div",
        { staticClass: "content-nav" },
        _vm._l(_vm.saleStatusList, function (i, n) {
          return _c("div", { key: n }, [
            i.isShowAggData
              ? _c("div", { staticClass: "content-nav_item" }, [
                  _c("div", {
                    staticClass: "content-nav_itemBefore",
                    style: _vm.getBg(i.color),
                  }),
                  _vm._v(
                    "\n                " +
                      _vm._s(i.name) +
                      " (" +
                      _vm._s(i.roomSize) +
                      "/" +
                      _vm._s(Math.round(i.percent * 10000) / 100 + "%") +
                      ")\n             "
                  ),
                ])
              : _vm._e(),
          ])
        }),
        0
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "content-main",
          style: _vm.isTransverse ? "display: flex;overflow: scroll;" : "",
        },
        _vm._l(_vm.buildList, function (item, num) {
          return _c(
            "div",
            {
              key: item.id,
              staticClass: "House",
              style: _vm.isTransverse ? "" : "overflow: scroll",
              attrs: { "track-by": "id" },
            },
            [
              _c(
                "div",
                { staticClass: "HouseTop" },
                [
                  _vm._m(0, true),
                  _vm._v(" "),
                  _vm._l(item.buildHeadBean.unitBeanList, function (i, n) {
                    return _c(
                      "div",
                      {
                        key: i.id,
                        staticClass: "HouseTop-item",
                        attrs: { "track-by": "id" },
                      },
                      [
                        _c("div", { staticClass: "HouseTop-item_name" }, [
                          _vm._v(" " + _vm._s(i.name) + " "),
                        ]),
                        _vm._v(" "),
                        _vm._l(i.unitHoldBeanList, function (ii, nn) {
                          return _c(
                            "div",
                            {
                              key: ii.id,
                              staticClass: "HouseTop-item_house",
                              class: "widthM" + i.isMore,
                              attrs: { "track-by": "id" },
                            },
                            [
                              ii.edit == true
                                ? _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value:
                                          _vm.buildList[num].buildHeadBean
                                            .unitBeanList[n].unitHoldBeanList[
                                            nn
                                          ].name,
                                        expression:
                                          "buildList[num].buildHeadBean.unitBeanList[n].unitHoldBeanList[nn].name",
                                      },
                                    ],
                                    staticStyle: {
                                      border: "0",
                                      width: "100%",
                                      "text-align": "center",
                                    },
                                    domProps: {
                                      value:
                                        _vm.buildList[num].buildHeadBean
                                          .unitBeanList[n].unitHoldBeanList[nn]
                                          .name,
                                    },
                                    on: {
                                      blur: function ($event) {
                                        return _vm.changeHoldname(
                                          $event,
                                          num,
                                          n,
                                          nn
                                        )
                                      },
                                      input: function ($event) {
                                        if ($event.target.composing) {
                                          return
                                        }
                                        _vm.$set(
                                          _vm.buildList[num].buildHeadBean
                                            .unitBeanList[n].unitHoldBeanList[
                                            nn
                                          ],
                                          "name",
                                          $event.target.value
                                        )
                                      },
                                    },
                                  })
                                : _c("span", [_vm._v(_vm._s(ii.name))]),
                            ]
                          )
                        }),
                      ],
                      2
                    )
                  }),
                ],
                2
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "HouseMain" },
                _vm._l(item.floorBeanList, function (i, n) {
                  return _c(
                    "div",
                    {
                      key: i.id,
                      staticClass: "HouseMain-item",
                      attrs: { "track-by": "id" },
                    },
                    [
                      _c("div", { staticClass: "HouseTop-item_unit" }, [
                        _c(
                          "div",
                          {
                            staticClass: "HouseTop-item_room",
                            staticStyle: { width: "94px", color: "#999" },
                          },
                          [
                            _vm._v(
                              "\n                          " +
                                _vm._s(i.number) +
                                "层\n                      "
                            ),
                          ]
                        ),
                      ]),
                      _vm._v(" "),
                      _vm._l(i.unitBeanList, function (ii, nn) {
                        return _c(
                          "div",
                          { key: ii.id, attrs: { "track-by": "id" } },
                          [
                            _c("room-item", {
                              attrs: {
                                roomBeanList: ii.roomBeanList,
                                saleStatusBeanList: _vm.saleStatusBeanList,
                                isMore: ii.isMore,
                                isMousedown: ii.isMousedownPro,
                                isMouseup: ii.isMouseupPro,
                                indexList: [num, n, nn],
                              },
                              on: {
                                mouseup: _vm.mouseupFn,
                                mousedown: _vm.mousedownFn,
                              },
                            }),
                          ],
                          1
                        )
                      }),
                    ],
                    2
                  )
                }),
                0
              ),
            ]
          )
        }),
        0
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "HouseTop-item" }, [
      _c("div", { staticClass: "HouseTop-item_name" }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "HouseTop-item_house", staticStyle: { width: "94px" } },
        [_vm._v("\n                        楼层\n                    ")]
      ),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }